<template>
  <div class="footer">

    <div class="footer__content">
      <div class="footer__content__item">
        <div class="footer__content__item__title">
          关于我们
        </div>
        <div class="footer__content__item__content">
          广东豪嘉制冷设备有限公司是专业的水族制冷设备制造商，致力于为客户提供高品质的产品和服务。
        </div>
      </div>

      <div class="footer__content__item">
        <div class="footer__content__item__title">
          产品中心
        </div>
        <div class="footer__content__item__content">
          <div>制冷设备</div>
          <div>玻璃定制</div>
          <div>水泵气泵</div>
          <div>配件辅材</div>
        </div>
      </div>

      <div class="footer__content__item">
        <div class="footer__content__item__title">
          服务支持
        </div>
        <div class="footer__content__item__content">
          <div>技术支持</div>
          <div>售后服务</div>
          <div>在线咨询</div>
          <div>常见问题</div>
        </div>
      </div>

      <div class="footer__content__item">
        <div class="footer__content__item__title">
          联系我们
        </div>
        <div class="footer__content__item__content">
          <div>地址：广东省佛山市南海区里水镇南海花博园农科路意美兰园对面</div>
          <div>电话：13556101918</div>
          <div>邮箱：hxliot@qq.com</div>
        </div>
      </div>
    </div>
    <div class="footer__copyright">
      广东豪嘉制冷设备有限公司 | 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备17060201号-2</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComp'
}
</script>

<style scoped lang="scss">
.footer {
  background: #111827;
  padding: 48px 112px 12px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .footer__content {
    display: flex;
    gap: 32px;

    .footer__content__item {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 18px;

      .footer__content__item__title {
        color: #FFFFFF;
        font-family: "Inter";
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
      }

      .footer__content__item__content {
        color: #9CA3AF;
        font-family: "Inter";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  .footer__copyright {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #9CA3AF;
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    border-top: 1px solid #1F2937;

    a {
      color: #9CA3AF;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        color: #FFFFFF;
        text-decoration: underline;
      }
    }
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 24px 16px 8px;

    .footer__content {
      flex-direction: column;
      gap: 20px;

      .footer__content__item {
        .footer__content__item__title {
          font-size: 15px;
          line-height: 24px;
        }

        .footer__content__item__content {
          font-size: 13px;
          line-height: 18px;
          flex-direction: row;

          div {
            width: fit-content;
          }
        }

        // 地址换行处理
        div:contains('地址：') {
          white-space: normal;
          word-break: break-word;
        }
      }
    }

    .footer__copyright {
      font-size: 12px;
      height: 30px;

      a {
        font-size: 12px;
      }
    }
  }
}
</style>